const state = {
  categories: []
}

export default state
